import {lazy, Suspense} from 'react'
import {Routes, Route, useNavigate} from 'react-router-dom'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
`

const Board = styled.div`
  display: flex;
  flex: 1;
`

const Index = () => {
  const List = lazy(() => import('./List'))
  const Regis = lazy(() => import('./Regis'))

  return (
    <Container>
      <Board>
        <Suspense fallback={''}>
          <Routes>
            {['/', '/:pageNum'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<List/>}
              />
            ))}

            {['/regis', '/regis/:id'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<Regis/>}
              />
            ))}
          </Routes>
        </Suspense>
      </Board>
    </Container>
  )
}

export default Index
